import { useState } from "react";
import BackofficeLayout from "@/components/layouts/BackofficeLayout";
import ContentTree from "@/components/cms/ContentTree";
import ContentEditor from "@/components/cms/ContentEditor";
import TemplateEditor from "@/components/cms/TemplateEditor";
import FolderSettings from "@/components/cms/FolderSettings";
import type { CMSContent } from "@/models/CMS";

export default function CMS() {
  const [selectedContent, setSelectedContent] = useState<CMSContent | null>(
    null
  );

  return (
    <BackofficeLayout>
      <div className="flex flex-col">
        <h1 className="text-2xl font-semibold tracking-tight mb-6">
          Content Management
        </h1>
        <div className="flex space-x-6 bg-white rounded-lg border h-[calc(100vh-13rem)]">
          <ContentTree
            onSelect={setSelectedContent}
            selectedId={selectedContent?.id}
          />
          {selectedContent ? (
            selectedContent.type === "template" ? (
              <TemplateEditor
                key={selectedContent.id}
                content={selectedContent}
              />
            ) : (
              <div className="flex-1 overflow-y-auto">
                {/* Top-level folders carry compatibility + scope (8-Sep). */}
                {!selectedContent.parent_id && (
                  <FolderSettings
                    key={selectedContent.id}
                    content={selectedContent}
                  />
                )}
                <ContentEditor contentId={selectedContent.id} />
              </div>
            )
          ) : (
            <div className="flex-1 flex items-center justify-center text-muted-foreground">
              Select a content item to edit
            </div>
          )}
        </div>
      </div>
    </BackofficeLayout>
  );
}
